import React, { useEffect, useRef, useState } from 'react';
import Upcoming from "../../Images/Categorey-Icon-7.svg.png";

const UpcomingExam = () => {
    const [isPaused, setIsPaused] = useState(false);
    const sliderRef = useRef(null);

    useEffect(() => {
        const slider = sliderRef.current;
        if (slider) {
            slider.insertAdjacentHTML('afterend', slider.outerHTML);
            slider.nextSibling.setAttribute('aria-hidden', 'true');
        }
    }, []);

    const animationStyles = `
        @keyframes infiniteScroll {
            from {
                transform: translateX(0);
            }
            to {
                transform: translateX(-100%);
            }
        }
        .animate-infinite-scroll {
            display: flex;
            animation: infiniteScroll 60s linear infinite;
        }
         .paused-animation {
            animation-play-state: paused;
        }
    `;

    const handleItemClick = () => {
        setIsPaused(true);
    };

    return (
        <div id="upcoming" className="bg-white w-full py-12 text-center font-oswald">
            <div className="flex items-center justify-center">
                <p
                    style={{ backgroundColor: "#EFEEFE" }}
                    className="border-2 border rounded-full bg-bgBlue py-2 px-6 font-bold text-bgBlue"
                >
                    Trending
                </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
                Upcoming <span className="text-purple">Exams</span>
            </h2>
            <p className="text-sm text-gray-900 mb-4 lg:w-1/2 lg:m-auto">
          “Get ready! Upcoming exams are just around the corner — start your preparation today!”
            </p>
            <br />
            <div className=" ">
                <div className="text-center">
                    <style>
                        {animationStyles}
                    </style>
                    <div
                        className="w-full  p-4 inline-flex flex-nowrap overflow-hidden"
                        style={{
                            // maskImage: 'linear-gradient(to right, transparent 0, black 128px, black calc(100% - 128px), transparent 100%)'
                        }}
                    >
                        <ul
                            ref={sliderRef}
                            className={`flex animate-infinite-scroll`}
                        >
                            {[...Array(2)].map((_, index) => (
                                <React.Fragment key={index}>
                                    <li
                                        className="flex-shrink-0 w-1/4 lg:w-1/5 lg:px-4 p-2 "
                                        onClick={handleItemClick}
                                    >
                                        <div
                                            style={{ backgroundColor: "#F1D9CC" }}
                                            className="flex flex-col shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52 transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                                        >
                                            <div className="flex justify-between m-auto lg:m-0">
                                                <img src={Upcoming} alt="Exam 1" className="w-fit" />
                                            </div>
                                            <br />
                                            <div className="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                                                <span className="text-xl font-semibold font-oswald text-black">
                                                    SSC MTS,SSC CHSL,SSC CGL
                                                </span>
                                                <span className="text-sm font-bold">Apply Now</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li
                                        className="flex-shrink-0 w-1/4 lg:w-1/5 lg:px-4 p-2"
                                        onClick={handleItemClick}
                                    >
                                        <div
                                            style={{ backgroundColor: "#EDEAFF" }}
                                            className="flex flex-col shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52 transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                                        >
                                            <div className="flex justify-between m-auto lg:m-0">
                                                <img src={Upcoming} alt="Exam 2" className="w-fit" />
                                            </div>
                                            <br />
                                            <div className="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                                                <span className="text-xl font-semibold font-oswald text-black">
                                                    SSC MTS,SSC CHSL,SSC CGL
                                                </span>
                                                <span className="text-sm font-bold">Apply Now</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li
                                        className="flex-shrink-0 w-1/4 lg:w-1/5 lg:px-4 p-2"
                                        onClick={handleItemClick}
                                    >
                                        <div
                                            style={{ backgroundColor: "#EDEAFF" }}
                                            className="flex flex-col shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52 transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                                        >
                                            <div className="flex justify-between m-auto lg:m-0">
                                                <img src={Upcoming} alt="Exam 2" className="w-fit" />
                                            </div>
                                            <br />
                                            <div className="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                                                <span className="text-xl font-semibold font-oswald text-black">
                                                    SSC MTS,SSC CHSL,SSC CGL
                                                </span>
                                                <span className="text-sm font-bold">Apply Now</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li
                                        className="flex-shrink-0 w-1/4 lg:w-1/5 lg:px-4 p-2"
                                        onClick={handleItemClick}
                                    >
                                        <div
                                            style={{ backgroundColor: "#EDEAFF" }}
                                            className="flex flex-col shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52 transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                                        >
                                            <div className="flex justify-between m-auto lg:m-0">
                                                <img src={Upcoming} alt="Exam 2" className="w-fit" />
                                            </div>
                                            <br />
                                            <div className="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                                                <span className="text-xl font-semibold font-oswald text-black">
                                                    SSC MTS,SSC CHSL,SSC CGL
                                                </span>
                                                <span className="text-sm font-bold">Apply Now</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li
                                        className="flex-shrink-0 w-1/4 lg:w-1/5 lg:px-4 p-2"
                                        onClick={handleItemClick}
                                    >
                                        <div
                                            style={{ backgroundColor: "#EDEAFF" }}
                                            className="flex flex-col shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52 transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                                        >
                                            <div className="flex justify-between m-auto lg:m-0">
                                                <img src={Upcoming} alt="Exam 2" className="w-fit" />
                                            </div>
                                            <br />
                                            <div className="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                                                <span className="text-xl font-semibold font-oswald text-black">
                                                    SSC MTS,SSC CHSL,SSC CGL
                                                </span>
                                                <span className="text-sm font-bold">Apply Now</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li
                                        className="flex-shrink-0 w-1/4 lg:w-1/5 lg:px-4 p-2"
                                        onClick={handleItemClick}
                                    >
                                        <div
                                            style={{ backgroundColor: "#EDEAFF" }}
                                            className="flex flex-col shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52 transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                                        >
                                            <div className="flex justify-between m-auto lg:m-0">
                                                <img src={Upcoming} alt="Exam 2" className="w-fit" />
                                            </div>
                                            <br />
                                            <div className="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                                                <span className="text-xl font-semibold font-oswald text-black">
                                                    SSC MTS,SSC CHSL,SSC CGL
                                                </span>
                                                <span className="text-sm font-bold">Apply Now</span>
                                            </div>
                                        </div>
                                    </li>
                                    {/* Add more items as needed */}
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpcomingExam;
